
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import HomeworkItem from './HomeworkItem.vue'
import { EnumHomeworkTaskPublishStatus, EnumHomeworkBizType } from '@xt/client'
import type { ClasshourDetail as TClasshourDetail } from '@xt/client/entities/course-v2/types.d'
import EmptyStatus from '@xt/www/components/emptyStatus/index.vue'
import { EnumEmptyStatus } from '@xt/client/utils/empty-status/index'

@Observer
@Component({
  components: { HomeworkItem, EmptyStatus }
})
export default class ClasshourHomework extends Vue {
  @Prop({}) data: TClasshourDetail['homeworkTaskList']

  get EnumEmptyStatus() {
    return EnumEmptyStatus
  }

  get EnumHomeworkBizType() {
    return EnumHomeworkBizType
  }

  get EnumHomeworkTaskPublishStatus() {
    return EnumHomeworkTaskPublishStatus
  }

  get GuideData() {
    return this.$store.$courseV2.GuideData
  }

  showEditWaitReview(item: TClasshourDetail['homeworkTaskList'][number]) {
    return (
      Array.isArray(item.memberHomeworks) &&
      !item.reviewed &&
      item.taskPriorityReviewedEnable &&
      item.memberHomeworks.length > 1 &&
      item.memberHomeworks.some(i => !i.reviewed && i.reviewedFlag === 0)
    )
  }

  getTaskHasReviewed(item: TClasshourDetail['homeworkTaskList'][number]) {
    return item.reviewed === true
  }

  handleClickHomeworkItem(id: number) {
    this.$emit('click-homework-item', id)
  }

  handleClickHomeworkTaskTitle(item: TClasshourDetail['homeworkTaskList'][number]) {
    if (item.publishStatus === 0) {
      this.$message.error('作业任务未发布')
      return
    }

    this.$emit('click-homework-title', item.id)
  }

  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
